import { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { IJobBase, MessageType } from '../../../types'
import { SettingButton } from '../../atoms/SettingButton'
import styles from './index.module.scss'
import { useStores } from '../../../utils'

type Props = {
  job: IJobBase
}

export const RemoveJobButton: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation('jobs')
  const { messages, viewer } = useStores()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const removeMyJobBookmark = async () => {
    if (viewer.isSignedIn) {
      setIsSubmitting(true)
      const isSuccessful = await viewer.viewer?.removeMyJobBookmark(job.id)
      if (isSuccessful) {
        messages.add({
          type: MessageType.Info,
          body: t('保存を解除しました'),
          isTranslated: true,
          ttl: 5000,
        })
      }
      setIsSubmitting(false)
    }
  }
  return (
    <div className={styles.container}>
      <SettingButton
        componentType='button'
        color='grayOutline'
        onClick={() => removeMyJobBookmark()}
        isLoading={isSubmitting}
        disabled={isSubmitting || !viewer.isSignedIn}
        loadingColor='black'
      >
        {t('保存を解除')}
      </SettingButton>
    </div>
  )
})
